import React from "react";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import ShareIcon from "@material-ui/icons/Share";
import CircularProgress from "@material-ui/core/CircularProgress";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import MaterialTable from "material-table";
import TextField from "@material-ui/core/TextField";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import ChipInput from "material-ui-chip-input";
import Chip from "@material-ui/core/Chip";
import Button from "@material-ui/core/Button";
import colors from "../../../common/src/theme/interior/colors";
import { makeStyles } from "@material-ui/core/styles";
import {
  getFiles,
  deleteFile,
  updateFile,
  updateProject,
  deleteProject,
  sendMail,
  getUsername,
} from "../../../common/src/api";

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    "& div": {
      width: "100%",
    },
  },
}))(MuiAccordionDetails);

const useStyles = makeStyles((props) => ({
  root: {
    background: "white",
    borderRadius: 4,
    border: (props) =>
      `1px solid ${props.invalid ? colors.error : colors.inactiveIcon}`,
    paddingTop: 11,
    paddingLeft: 11,
    paddingRight: 11,
    "&:focus-within": {
      border: "1px solid #fdbf10",
    },
  },
  inputRoot: {
    padding: 11,
    paddingTop: "0px !important",
    borderRadius: 4,
    "&:hover": {
      "&::before": {
        borderBottom: "none",
      },
      "&::after": {
        borderBottom: "none",
      },
    },
    "&::before": {
      borderBottom: "none",
    },
    "&::after": {
      borderBottom: "none",
    },
  },
  input: {
    padding: 0,
    fontSize: 16,
    height: "unset",
    lineHeight: 1.5,
  },
  colorSecondary: {
    background: colors.error,
    color: "white",
  },
}));


const SuccessBox = (props) => (
  <div style={{ borderRadius: 4, background: "white", padding: 24 }}>
    <Typography variant="h5" align="center">
      ¡Listo!
    </Typography>
    <Typography align="center" style={{ color: "#888", marginTop: 8 }}>
      Se ha enviado un correo con los datos para revisar el proyecto.
    </Typography>
    <div style={{ display: "flex", justifyContent: "center", marginTop: 16 }}>
      <Button
        color="primary"
        variant="contained"
        onClick={props.onClick}
      >
        ENVIAR OTRO
      </Button>
    </div>
  </div>
);

const ProjectBar = (props) => {
  const jwt = localStorage.getItem("auth") || sessionStorage.getItem("auth");
  const [loading, setLoading] = React.useState(true);
  const [models, setModels] = React.useState([]);
  const [expanded, setExpanded] = React.useState(false);
  const [editing, setEditing] = React.useState(false);
  const [deleting, setDeleting] = React.useState(false);
  const [name, setName] = React.useState(props.name);
  const [newName, setNewName] = React.useState(props.name);
  const { id, onAdd, onOpen, onDelete, onClickSensors } = props;

  const [openShareModal, setOpenShareModal] = React.useState(false);
  const [shareEmails, setShareEmails] = React.useState([]);
  const [chipsValid, setChipsValid] = React.useState(true);
  const [success, setSuccess] = React.useState(false);

  const classes = useStyles();
  const emailRegex = /^\w+([.\-+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

  const [username, setUsername] = React.useState("");

  React.useEffect(() => {
    if (expanded) {
      const interval = setInterval(() => {
        getFiles(jwt, id, (res) => {
          const info = formatData(res);
          setModels(info);
        });
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [expanded, id, jwt]);

  React.useEffect(() => {
    if (jwt) getUsername(jwt, (u) => setUsername(u));
  }, [jwt]);

  const refreshFiles = () => {
    setLoading(true);
    getFiles(jwt, id, (res) => {
      const info = formatData(res);
      setLoading(false);
      setModels(info);
    });
  };

  const formatData = (data) =>
    data.map((file) => ({
      id: file.id,
      tag: file.type,
      name: file.name,
      filename: file.original_name,
      loading: file.loading,
      status: file.error ? (
        <div className="d-flex align-items-center" style={{ color: "#f50057" }}>
          <ErrorOutlineIcon fontSize="small" />{" "}
          <span className="ml-2">Error</span>
        </div>
      ) : file.loading ? (
        <div className="d-flex align-items-center">
          <CircularProgress style={{ margin: 2 }} color="inherit" size={16} />
          <span className="ml-2">Cargando</span>
        </div>
      ) : (
        <div className="d-flex align-items-center" style={{ color: "#20e43b" }}>
          <CheckCircleOutlineOutlinedIcon fontSize="small" />{" "}
          <span className="ml-2">Listo</span>
        </div>
      ),
    }));

  const handleExpand = (value) => {
    setExpanded(value);
    value ? refreshFiles() : setLoading(true);
  };

  const handleChipRender = (chip, index) => {
    const { value } = chip;
    const isValid = emailRegex.test(value);
  
    return (
      <Chip
        key={index}
        label={value}
        onDelete={() => handleDeleteChip(index)}
        className={!isValid ? classes.colorSecondary : ""}
        style={{ margin: "0 8px 8px 0" }}
      />
    );
  };

  const handleAddChip = (chip) => {
    const normalizedChip = chip.trim().toLowerCase();
    
    // Evitar duplicados
    if (shareEmails.includes(normalizedChip)) return;
  
    const updated = [...shareEmails, normalizedChip];
    setShareEmails(updated);
  
    // Validar todos los correos actuales
    const allValid = updated.every((email) => emailRegex.test(email));
    setChipsValid(allValid);
  };
  
  const handleDeleteChip = (index) => {
    const updated = [...shareEmails];
    updated.splice(index, 1);
    setShareEmails(updated);
  
    // Revalidar después de eliminar
    setChipsValid(updated.every((email) => emailRegex.test(email)));
  };

  const handleSendShare = () => {
    const hasInvalid = shareEmails.some((e) => !emailRegex.test(e));
    if (hasInvalid || shareEmails.length === 0) {
      setChipsValid(false);
      return;
    }
    setChipsValid(true);
  
    sendMail(
      jwt,
      id,
      username,
      shareEmails,
      () => {
        setSuccess(true);
        setShareEmails([]);
      },
      () => {
        alert("Error al compartir el proyecto.");
      }
    );
  };
  
  return (
    <Accordion expanded={expanded} onChange={() => handleExpand(!expanded)}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center">
            {editing ? (
              <>
                <TextField
                  label="Nombre del proyecto"
                  value={newName}
                  onClick={(event) => event.stopPropagation()}
                  onChange={(event) => setNewName(event.target.value)}
                />
                <IconButton
                  className="ml-2"
                  onClick={(event) => {
                    event.stopPropagation();
                    updateProject(jwt, id, { name: newName }, () => {
                      setName(newName);
                      setEditing(false);
                    });
                  }}
                >
                  <CheckIcon color="action" fontSize="small" />
                </IconButton>
                <IconButton
                  className="ml-2"
                  onClick={(event) => {
                    event.stopPropagation();
                    setEditing(false);
                    setNewName(name);
                  }}
                >
                  <CloseIcon color="action" fontSize="small" />
                </IconButton>
              </>
            ) : deleting ? (
              <>
                <Typography variant="h6">
                  ¿Desea eliminar este proyecto?
                </Typography>
                <IconButton
                  className="ml-2"
                  onClick={(event) => {
                    event.stopPropagation();
                    deleteProject(jwt, id, () => onDelete(props.index));
                  }}
                >
                  <CheckIcon color="action" fontSize="small" />
                </IconButton>
                <IconButton
                  className="ml-2"
                  onClick={(event) => {
                    event.stopPropagation();
                    setDeleting(false);
                  }}
                >
                  <CloseIcon color="action" fontSize="small" />
                </IconButton>
              </>
            ) : (
              <>
                <h5>{name}</h5>
                <IconButton
                  className="ml-3"
                  onClick={(event) => {
                    event.stopPropagation();
                    setEditing(true);
                  }}
                >
                  <EditIcon color="action" fontSize="small" />
                </IconButton>
                <IconButton
                  className="ml-2"
                  onClick={(event) => {
                    event.stopPropagation();
                    setDeleting(true);
                  }}
                >
                  <DeleteIcon color="action" fontSize="small" />
                </IconButton>
              </>
            )}
          </div>
          <div
            className="d-flex justify-content-around"
            style={{ width: "120px" }}
          >
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setOpenShareModal(true);
              }}
            >
              <ShareIcon />
            </IconButton>
            <IconButton
              onClick={(event) => {
                event.stopPropagation();
                handleExpand(true);
                onAdd(refreshFiles);
              }}
            >
              <AddCircleIcon />
            </IconButton>
            <IconButton
              onClick={(event) => {
                event.stopPropagation();
                onOpen();
              }}
            >
              <OpenInNewIcon />
            </IconButton>
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <MaterialTable
          title=""
          isLoading={loading}
          columns={[
            {
              field: "tag",
              title: "Tipo",
              lookup: { ARC: "ARC", STR: "STR", MEP: "MEP" },
            },
            {
              field: "name",
              title: "Nombre",
            },
            {
              field: "filename",
              title: "Archivo",
              editable: "never",
            },
            {
              field: "status",
              title: "Estado",
              editable: "never",
              sorting: false,
            },
          ]}
          data={models}
          editable={{
            onRowDelete: (oldData) =>
              deleteFile(jwt, oldData.id, () => {
                const index = oldData.tableData.id;
                let newModels = models;
                delete newModels[index];
                newModels = newModels.filter((model) => !!model);
                setModels(newModels);
              }),
          }}
          cellEditable={{
            cellStyle: {},
            onCellEditApproved: (newValue, oldValue, rowData, columnDef) => {
              const data = {};
              data[columnDef.field] = newValue;
              return updateFile(jwt, rowData.id, data, (data) => {
                const index = rowData.tableData.id;
                let newModels = models;
                let model = newModels[index];
                model[columnDef.field] = newValue;
                newModels[index] = model;
                setModels(newModels);
              });
            },
          }}
          options={{
            toolbar: false,
            showTitle: false,
            paging: false,
            actionsColumnIndex: 4,
          }}
          localization={{
            header: {
              actions: "Acciones",
            },
            body: {
              deleteTooltip: "Eliminar",
              editTooltip: "Editar",
              emptyDataSourceMessage:
                "No se han cargado modelos a este proyecto.",
              editRow: {
                deleteText: "¿Desea eliminar este modelo?",
                cancelTooltip: "Cancelar",
                saveTooltip: "Continuar",
              },
            },
          }}
          actions={[
            {
              icon: "sensors",
              tooltip: "Sensores",
              onClick: (event, rowData) => onClickSensors(rowData.id),
            },
          ]}
        />
      </AccordionDetails>
      <Dialog 
        open={openShareModal} 
        onClose={() => {
          setOpenShareModal(false);
          setSuccess(false);
          setShareEmails([]);
          setChipsValid(true);
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Compartir proyecto</DialogTitle>
        <DialogContent>
          {success ? (
            <SuccessBox onClick={() => setSuccess(false)} />
          ) : (
            <>
              <ChipInput
                value={shareEmails}
                classes={{
                  root: classes.root,
                  inputRoot: classes.inputRoot,
                  input: classes.input,
                }}
                onAdd={handleAddChip}
                onChange={(chips) => {
                  setShareEmails(chips);
                  setChipsValid(chips.every((email) => emailRegex.test(email)));
                }}
                placeholder="Ingresa uno o varios correos (separados por coma)"
                newChipKeyCodes={[188]}
                fullWidth
                chipRenderer={handleChipRender}
                disableUnderline
              />
              {!chipsValid && (
                <Typography color="error" style={{ marginTop: 8 }}>
                  Uno o más correos no son válidos.
                </Typography>
              )}
            </>
          )}
        </DialogContent>
        {!success && (
          <DialogActions>
            <Button onClick={() => setOpenShareModal(false)} color="secondary">
              Cancelar
            </Button>
            <Button onClick={handleSendShare} color="primary">
              Enviar
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </Accordion>
  );
};

export default ProjectBar;
